import { styled } from "styled-components";

export const ImageContainer = styled.div`
  position: relative;
  display: block;

  padding-top: 66.83673469%;
  width: 100%;
  height: unset;
`;
